import React from "react";
import { Root } from "react-dom/client";

import RecommendationArticles from "../components/articles-container/recommendation-articles";
import { fetchRecommendations } from "./fetch-recommendations";
import { LazyFragmentData, RecommendationPayload, RecommendationRequest } from "../types/fragment";
import { OrderModalOpenEvent, ProductRecommendationRenderedEvent } from "../types/app-shell-events";
import { RecommendationArticlesProps } from "../types/articles";

let root: Root | undefined;

export function StartReloader(
  recommendationRoot: Root,
  fragmentData: LazyFragmentData,
  recoReqData: RecommendationRequest
) {
  root = recommendationRoot;
  const clickedSalesArticleNumbers = recoReqData.salesArticleNumbersToIgnore ?? [];

  shell?.messageBroker.subscribeTo(
    "ESPP.OrderModal.Open",
    (payload) => {
      if (payload) {
        const modalData = payload as OrderModalOpenEvent;
        if (!clickedSalesArticleNumbers.includes(modalData.salesArticleNo)) {
          clickedSalesArticleNumbers.push(modalData.salesArticleNo);
        }
      }
    },
    "ESPP2.ProductRecommendation"
  );

  shell?.messageBroker.subscribeTo(
    "ESPP.OrderModal.Closed",
    () => {
      const requestData: RecommendationRequest = {
        allowAiRecommendations: recoReqData.allowAiRecommendations,
        isPrivateCustomer: recoReqData.isPrivateCustomer,
        salesArticleNumbersToIgnore: clickedSalesArticleNumbers,
        freeShippingThresholdNet: recoReqData.freeShippingThresholdNet,
        basketTotalValueNet: recoReqData.basketTotalValueNet
      };
      fetchRecommendations(fragmentData, requestData, false);
    },
    "ESPP2.ProductRecommendation"
  );
}

export function reRenderRecommendationRoot(
  payload: RecommendationPayload,
  fragmentData: LazyFragmentData
) {
  const props: RecommendationArticlesProps = {
    recommendations: payload.recommendations,
    currencyInformation: payload.currencyInformation,
    l10n: fragmentData.l10n,
    location: fragmentData.location,
    defaultConfigId: fragmentData.defaultConfigId,
    useDefaultId: fragmentData.useDefaultId,
    customConfigId: fragmentData.customConfigId
  };

  root?.render(<RecommendationArticles {...props} />);

  const eventData: ProductRecommendationRenderedEvent = {
    isInitialRender: false,
    fragmentName: fragmentData.location,
    requestConfigId: fragmentData.useDefaultId
      ? fragmentData.defaultConfigId
      : fragmentData.customConfigId!
  };

  shell?.messageBroker.publishTo("ESPP2.ProductRecommendation.Rendered", eventData);
}
